import * as React from "react";
import { Context } from "./_context";
export const ShoppingCartIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.5 19a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM3 3a1 1 0 0 1 .948.684L4.721 6H22a1.001 1.001 0 0 1 .958 1.287l-3 10A1 1 0 0 1 19 18H7a1 1 0 0 1-.958-.713l-3-10L2.279 5H.5V3H3Zm4.744 13h10.512l2.4-8H5.344l2.4 8Z", fill: "currentColor" }));
  return iconset[size];
};
ShoppingCartIcon.iconId = "cNY4os";
